import React from 'react';
import {
  Create,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  ImageInput,
  ImageField,
} from 'react-admin';

export const BannerCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ImageInput source="image" label="Image" accept="image/*" isRequired>
        <ImageField source="src" title="title" />
      </ImageInput>

      <TextInput source="link_url" label="Link url" defaultValue="#" />

      <NumberInput source="sort_order" label="Sort order" defaultValue={0} />
      <BooleanInput source="is_active" label="Is active" defaultValue={true} />
    </SimpleForm>
  </Create>
);

// ---------- EDIT ----------
const formatImage = (value) => {
  if (!value) return value;
  if (typeof value === 'string') {
    return { src: value, title: value };
  }
  return value;
};

const parseImage = (value) => {
  if (!value) return null;
  if (value.rawFile) return value;
  return value.src;
};

export const BannerEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ImageInput
        source="image"
        label="Image"
        accept="image/*"
        format={formatImage}
        parse={parseImage}
      >
        <ImageField source="src" title="title" />
      </ImageInput>

      <TextInput source="link_url" label="Link url" />

      <NumberInput source="sort_order" label="Sort order" />
      <BooleanInput source="is_active" label="Is active" />
    </SimpleForm>
  </Edit>
);